function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (t, n) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = n(require("@djforth/viewport-detection-fp"), require("lodash/isEmpty")) : "function" == typeof define && define.amd ? define(["@djforth/viewport-detection-fp", "lodash/isEmpty"], n) : (t = t || self).VanillaCarousel = n(t.ViewportDetect, t.isEmpty);
}(this, function (d, o) {
  "use strict";

  function a(t, n, e) {
    return n in t ? Object.defineProperty(t, n, {
      value: e,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[n] = e, t;
  }

  function r(n, t) {
    var e = Object.keys(n);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(n);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(n, t).enumerable;
      })), e.push.apply(e, r);
    }

    return e;
  }

  function v(n) {
    for (var t = 1; t < arguments.length; t++) {
      var e = null != arguments[t] ? arguments[t] : {};
      t % 2 ? r(Object(e), !0).forEach(function (t) {
        a(n, t, e[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(e)) : r(Object(e)).forEach(function (t) {
        Object.defineProperty(n, t, Object.getOwnPropertyDescriptor(e, t));
      });
    }

    return n;
  }

  function p(t) {
    return function (t) {
      if (Array.isArray(t)) {
        for (var n = 0, e = new Array(t.length); n < t.length; n++) {
          e[n] = t[n];
        }

        return e;
      }
    }(t) || function (t) {
      if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
    }(t) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }();
  }

  d = d && d.hasOwnProperty("default") ? d.default : d, o = o && o.hasOwnProperty("default") ? o.default : o;

  var m = function r(o) {
    for (var t = arguments.length, a = new Array(1 < t ? t - 1 : 0), n = 1; n < t; n++) {
      a[n - 1] = arguments[n];
    }

    return o.length <= a.length ? o.apply(void 0, a) : function () {
      for (var t = arguments.length, n = new Array(t), e = 0; e < t; e++) {
        n[e] = arguments[e];
      }

      return r.apply(void 0, [o].concat(a, n));
    };
  },
      y = {
    items: "carousel__item",
    autoplay: !1,
    arrows: !0,
    holder: "carousel__inner",
    naturalScroll: !0,
    playBtn: !0
  },
      g = ["arrows", "items", "control", "holder", "autoplay", "playBtn", "svg"],
      h = function h(t, n, e) {
    var r = t.dataset[e];
    return void 0 === r ? n : v({}, n, a({}, e, r = /true|false/.test(r) ? JSON.parse(r) : r));
  },
      u = function u(t, a) {
    return t.map(function (t, n) {
      var e = t.item,
          r = t.dot,
          o = t.active;
      return function (t, n) {
        !function (t) {
          var n = t.querySelector(".current");
          t.classList.remove("dots-nav__button--active"), n.innerHTML = "";
        }(n), function (t) {
          t.setAttribute("aria-hidden", !0);
        }(t);
      }(e, r), {
        active: n === a,
        dot: r,
        exit: o,
        item: e
      };
    });
  },
      b = function b(t, e, n) {
    var o = t.map(function (t, n) {
      return {
        active: 0 === n,
        dot: e[n] || null,
        exit: !1,
        item: t
      };
    }),
        a = 0,
        i = function (t) {
      var n = 0,
          e = function (e) {
        return function (t, n) {
          return e < t + n ? 0 : t + n < 0 ? e : t + n;
        };
      }(t.length - 1);

      return function () {
        var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : "next";
        return n = "number" == typeof t ? t : e(n, "previous" === t ? -1 : 1);
      };
    }(t),
        c = function (r) {
      return function (t, n) {
        var e = u(t, n);
        return r(n), function (t, n) {
          var e = t[n],
              r = e.dot,
              o = e.item;
          !function (t) {
            var n = t.querySelector(".current");
            t.classList.add("dots-nav__button--active"), n.innerHTML = "(Current slide)";
          }(r), function (t) {
            t.setAttribute("aria-hidden", "false");
          }(o);
        }(e, n), e;
      };
    }(n);

    return {
      get: function get() {
        return {
          active: function (t) {
            var n = t.find(function (t) {
              return t.active;
            });
            return n ? n.item : null;
          }(o),
          exit: function (t) {
            var n = t.find(function (t) {
              return t.exit;
            });
            return n ? n.item : null;
          }(o)
        };
      },
      move: function move(t) {
        a = i(t), o = c(o, a);
      },
      set: function set(r) {
        var t = o.findIndex(function (t) {
          var n = t.dot,
              e = t.item;
          return n === r || e === r;
        });
        return a !== t && (a = i(t), o = c(o, a), !0);
      }
    };
  },
      c = "carousel__item--animating",
      s = function s(t) {
    return "true" === t.getAttribute("aria-hidden");
  },
      n = function n(t, _n) {
    t(!1), _n.classList.remove(c), s(_n) && (_n.display = "none", _n.style.transform = "translateX(-100%)", _n.display = "");
  },
      e = function e(t, n, _e) {
    window.requestAnimationFrame(function () {
      t(!0), n.classList.add(c), n.style.transform = "translateX(".concat(_e, ") translateZ(0)");
    });
  },
      w = function w() {
    var r = function () {
      var r = [];
      return {
        addListener: function addListener(t, n, e) {
          r.push({
            target: t,
            event: n,
            fn: e
          }), t.addEventListener(n, e, !1);
        },
        removeListeners: function removeListeners() {
          0 < r.length && (r.forEach(function (t) {
            var n = t.target,
                e = t.event,
                r = t.fn;
            n.removeEventListener(e, r, !1), n.classList.remove(c);
          }), r = []);
        }
      };
    }(),
        t = function t(_t) {
      return _t;
    },
        o = m(n, t),
        a = m(e, t),
        i = {
      animating: t,
      remove: function remove() {
        r.removeListeners();
      },
      start: function start(t, n, e) {
        return t.classList.remove(c), t.display = "none", t.style.transform = "translateX(".concat(n, ") translateZ(0)"), t.display = "", s(t) && (t.style.display = "none", t.offsetHeight, t.style.display = "block"), r.addListener(t, "transitionend", o.bind(i, t)), setTimeout(function () {
          a(t, e);
        }, 100);
      }
    };

    return i;
  },
      l = function l(t, n) {
    return t(), n.forEach(function (t) {
      clearTimeout(t);
    }), [];
  },
      f = function f(t, n) {
    return {
      In: t(n) ? "-100%" : "100%",
      Out: t(n) ? "100%" : "-100%"
    };
  },
      x = function x(t, n, e) {
    var r = n.active,
        o = n.exit,
        a = e.In,
        i = e.Out;
    return [t(r, a, 0), t(o, 0, i)];
  },
      E = function E(t, n, e, r) {
    (0, t.animating)() || (window.clearInterval(e), n.forEach(function (t) {
      t(r);
    }));
  },
      L = function L(t, n) {
    return !("next" !== n || !t) || "previous" === n && !t;
  },
      _ = function _(t, n, e) {
    var r = t.get,
        o = n.remove,
        a = n.start,
        i = [],
        c = m(l, o),
        u = m(f, m(L, e)),
        s = m(x, a);
    return function (t) {
      i = c(i), i = s(r(), u(t));
    };
  },
      A = function A(t, n, e, r) {
    var o = t.animating;
    return window.clearInterval(r), window.setInterval(function () {
      o() || n.forEach(function (t) {
        t("next");
      });
    }, e + 100);
  },
      S = function S(t, n) {
    var e,
        r = ["data-mobile", "data-tablet", "data-desktop"];
    t.forEach(function (t) {
      e = function (t, n) {
        for (var e = t[n]; null !== e && 1 !== e.nodeType;) {
          e = e.nextSibling;
        }

        return e;
      }(t, "firstChild"), function (t) {
        return t.reduce(function (t, n) {
          return !(!t || o(n));
        }, !0);
      }(r.map(function (t) {
        return e.getAttribute(t);
      })) ? (t.setAttribute("data-urls", "true"), function (t, n) {
        var e = t.dataset[n];
        t.style.backgroundImage = "url(".concat(e, ")");
      }(e, n)) : t.setAttribute("data-urls", "false");
    });
  },
      O = function O(t, n) {
    return "\n  <li class='arrow-nav__item arrow-nav__item--".concat(t, "'>").concat(n(t), "</li>\n");
  },
      j = function j(t) {
    var n = t.holder,
        e = t.config,
        r = e.arrows,
        o = e.control,
        a = e.svg,
        i = t.items,
        c = function (t, n) {
      var e = document.createElement("div");
      return e.setAttribute("aria-live", "polite"), e.setAttribute("aria-atomic", "true"), e.classList.add("liveregion"), e.classList.add("hidden"), e.textContent = "Item 1 of ".concat(n.length), t.appendChild(e), function (t) {
        e.textContent = "Item ".concat(t + 1, " of ").concat(n.length);
      };
    }(n, i);

    o.insertAdjacentHTML("beforeend", function (t) {
      return "\n    <div class='carousel__nav-dots'>\n        <ul class='dots-nav'>\n          ".concat(function (t) {
        return t.reduce(function (t, n, e) {
          return t + "\n      <li class='dots-nav__item'>\n        <button data-slide='".concat(e, "' class='dots-nav__button ").concat(function (t) {
            return 0 === t ? "dots-nav__button--active" : "";
          }(e), "'>\n          ").concat(function (t) {
            return "<span class='hidden'>\n  Promo ".concat(t, "\n</span>");
          }(e), "\n          ").concat(function (t) {
            return "<span class='hidden current'>\n  ".concat(0 === t ? "(Current slide)" : "", "\n</span>");
          }(e), "\n        </button>\n      </li>\n    ");
        }, "");
      }(t), "\n        </ul>\n    </div>");
    }(i));
    var u,
        s = p(o.querySelectorAll(".dots-nav__button"));
    return !0 === r && (o.insertAdjacentHTML("beforeend", function (t) {
      document.createElement("ul").className = "carousel-arrows-container";

      var n = function (n) {
        return function (t) {
          return "<button type='button' title='".concat(t, "' data-direction='").concat(t, "' class=\"arrow-nav__btn arrow-nav__btn--").concat(t, '">\n    ').concat(function (t) {
            return "<span class='hidden'>".concat(t, "</span>");
          }(t), "\n    ").concat(function (t, n) {
            return '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\n  <title>'.concat(t, '</title>\n  <use xlink:href="').concat(n, "#carousel-").concat(t, '"></use>\n</svg>');
          }(t, n), "\n</button>");
        };
      }(t);

      return "<ul class='arrow-nav'>\n    ".concat(O("previous", n), "\n    ").concat(O("next", n), "\n  </ul>");
    }(a)), u = p(o.querySelectorAll("[data-direction]"))), {
      arrowsNav: u,
      dots: s,
      liveRegion: c
    };
  },
      P = function P(t, n) {
    var e = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : "next";
    t.addEventListener("click", function (t) {
      t.preventDefault(), n(e);
    }, !1);
  },
      k = [49, 50, 51, 52, 53, 54, 55, 56, 57],
      i = function i(t, n) {
    var e = function (t, n) {
      var e = g.reduce(m(h, n), {});
      return e.element = n, e.control = document.getElementById(e.control) || n, e.itemsEl = p(document.querySelectorAll(".".concat(e.items))), e.holder = document.querySelector(".".concat(e.holder)) || document.querySelector(".".concat(y.holder)), e.autoplay && (e.autoPlay = 1e3 * parseInt(e.autoplay, 10)), v({}, y, {}, t, {}, e);
    }(t, n),
        r = function (t) {
      var n = t.element,
          e = t.items;
      return function (t, e) {
        return t.map(function (t, n) {
          return t.id = "".concat(e, "-item-").concat(n + 1), 0 === n || (t.style.transform = "translateX(-100%)", t.setAttribute("aria-hidden", "true")), t;
        });
      }(Array.prototype.slice.call(n.getElementsByClassName(e)), n.id);
    }(e),
        o = function (e) {
      var t = d(),
          r = t.getDevice(),
          o = t.getWidth();
      return t.addCallback(function (t, n) {
        o = n, r !== t && S(e, r = t);
      }), t.track(), {
        getDevice: function getDevice() {
          return r;
        },
        getWidth: function getWidth() {
          return o;
        }
      };
    }(r),
        a = o.getDevice,
        i = o.getWidth;

    S(r, a());

    var c = j({
      holder: n,
      config: e,
      items: r
    }),
        u = c.arrowsNav,
        s = c.dots,
        l = c.liveRegion,
        f = function (t, n) {
      var e,
          r = t.active,
          o = n.autoPlay,
          a = n.naturalScroll,
          i = w(),
          c = m(_, r, i, a),
          u = m(E, i, [r.move, c]),
          s = m(A, i, [r.move, c], o),
          l = o ? "play" : "stop";
      return {
        getSelected: function getSelected() {
          return r.get().active;
        },
        mover: function mover(t) {
          u(e, t);
        },
        next: function next() {
          u(e, "next");
        },
        pause: function pause() {
          window.clearInterval(e), e = void 0;
        },
        play: function play() {
          l = "play", e = s(e);
        },
        previous: function previous() {
          u(e, "previous");
        },
        restart: function restart() {
          "stop" !== l && (e = s(e));
        },
        selectItem: function selectItem(t) {
          !i.animating() && r.set(t) && (window.clearInterval(e), c("next"));
        },
        stop: function stop() {
          window.clearInterval(e), l = "stop", e = void 0;
        }
      };
    }({
      active: b(r, s, l),
      getWidth: i
    }, e);

    !function (t, n) {
      t.playBtn && function (t) {
        var n = t.playPause,
            e = n.playPause,
            r = n.playBtn,
            o = function (t, n) {
          var e = t.pauseSvg,
              r = t.playSvg,
              o = n.stop,
              a = n.play,
              i = "stop";
          return function () {
            return "stop" == i ? (i = "play", o(), r()) : (i = "stop", a(), e());
          };
        }(e, t.manageActive);

        r.addEventListener("click", function (t) {
          t.preventDefault(), t.target.innerHTML = o();
        });
      }({
        playPause: function (t) {
          var n = t.control,
              e = function (t) {
            var n = function (n) {
              return function (t) {
                return '<span class="hidden">'.concat(t, ' animation</span>\n<svg viewBox="0 0 24 24" width="24" height="24" xmlns="http://www.w3.org/2000/svg">\n    <title>').concat(t, ' Animation</title>\n    <use xlink:href="').concat(n, "#carousel-").concat(t, '"></use>\n    </svg >');
              };
            }(t);

            return {
              btn: function btn() {
                return '<button class="carousel-play__button" data-play-pause="true">\n        '.concat(n("pause"), "\n      </button>");
              },
              pauseSvg: function pauseSvg() {
                return n("pause");
              },
              playSvg: function playSvg() {
                return n("play");
              }
            };
          }(t.svg);

          return n.insertAdjacentHTML("beforeend", e.btn()), {
            playPause: e,
            playBtn: n.querySelector("[data-play-pause]")
          };
        }(t),
        manageActive: n
      });
    }(e, f), function (t, n) {
      var e = n.selectItem;
      t.forEach(function (t) {
        t.addEventListener("click", function (t) {
          t.preventDefault(), e(t.currentTarget);
        }, !1);
      });
    }(s, f), function (t, n) {
      n.next;
      var e = n.mover;
      n.previous;

      if (t) {
        var r = t.find(function (t) {
          return "next" === t.dataset.direction;
        });
        P(r, e);
        var o = t.find(function (t) {
          return "previous" === t.dataset.direction;
        });
        P(o, e, "previous");
      }
    }(u, f), function (t, n) {
      var e = t.element,
          r = t.itemsEl,
          o = n.mover,
          a = (n.next, n.previous, n.getSelected),
          i = n.selectItem;
      e.addEventListener("keydown", function (t) {
        switch (t.keyCode) {
          case 9:
            a() !== r[r.length - 1] && (t.preventDefault(), o("next"), a().querySelector("a").focus());
            break;

          case 39:
            t.preventDefault(), o("next"), a().querySelector("a").focus();
            break;

          case 37:
            t.preventDefault(), o("previous"), a().querySelector("a").focus();
            break;

          default:
            if (k.includes(t.keyCode)) {
              var n = k.indexOf(t.keyCode),
                  e = n < r.length ? r[n] : r[r.length - 1];
              i(e);
            }

        }
      });
    }(e, f), function (t, n) {
      var e = t.element,
          r = t.naturalScroll,
          o = n.mover,
          a = function (a) {
        var i = {
          x: 0,
          y: 0
        };
        return function (t) {
          var n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "start",
              e = t.changedTouches[0],
              r = e.pageX,
              o = e.pageY;
          return "start" === n ? (i.x = r, void (i.y = o)) : {
            distance: {
              x: r - i.x,
              y: o - i.y
            },
            direction: {
              horizontal: (a ? r > i.x : r < i.x) ? "next" : "previous",
              vertical: o > i.y ? "down" : "up"
            }
          };
        };
      }(r);

      e.addEventListener("touchstart", function (n) {
        return function (t) {
          n(t);
        };
      }(a), !1), e.addEventListener("touchend", function (o, a) {
        return function (t) {
          var n = o(t, "end"),
              e = n.direction.horizontal,
              r = n.distance;
          r.x < 10 && -10 < r.x || a(e);
        };
      }(a, o), !1);
    }(e, f), function (t, n) {
      var e = n.autoPlay,
          r = n.holder;
      e && (t.play(), function (t, n) {
        var e = n.pause,
            r = n.restart;
        t.addEventListener("focusin", function (t) {
          e();
        }), t.addEventListener("focusout", function (t) {
          r();
        });
      }(r, t), function (t, n) {
        var e = n.pause,
            r = n.restart;
        t.addEventListener("mouseenter", function (t) {
          e();
        }, !1), t.addEventListener("mouseleave", function (t) {
          r();
        }, !1);
      }(r, t));
    }(f, e);
  };

  return function () {
    var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
        n = p(document.querySelectorAll("[data-carousel]"));
    return n && 0 !== n.length ? (n.forEach(m(i, t)), n) : null;
  };
});